'use client'
import { useActionState } from "react";
import { ColorButton } from "./button";
import { H2 } from "./h";
import { TextInput } from "./textInput";
import Form from "next/form";
import { changePassword } from "@/app/api";

type ChangePasswordProps = {
    user_id: string,
    title: string,
    message: string,
    identifier: string,
    onClose: () => void
}

export function ChangePassword({ user_id, title, message, identifier, onClose }: ChangePasswordProps) {
    const [state, formAction, pending] = useActionState(changePassword, {
        values: { id: user_id, password: '' },
        errors: {},
        message: '',
    })
    if (state.success) setTimeout(() => onClose(), 100);
    return (
        <Form action={formAction}>
            <div className={`fixed flex flex-col p-4 gap-6 
                top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 z-30 rounded-md shadow-lg bg-silver-100 dark:bg-silver-500`}>

                <div className="flex flex-col p-4 gap-3 justify-center items-center">

                    <input type="hidden" name="user_id" id="user_id" defaultValue={user_id} required />

                    <div className="flex flex-col gap-2">
                        <p></p>
                        <H2>{title}</H2>
                        <p>{message}</p>
                        <p>{identifier}</p>

                        {/* password */}

                        <TextInput placeholder="Senha" name="password" id="password" type={"text"} minLength={6}
                            defaultValue={state?.values?.password} />

                        <p className="font-medium text-red-500">{state.message}</p>

                    </div>
                    <div className="flex p-2 gap-10">
                        <ColorButton type="button" onClick={() => { onClose() }}>
                            Cancelar
                        </ColorButton>

                        <ColorButton type="submit" disabled={pending}>
                            {pending
                                ? 'Atualizando...'
                                : 'Atualizar'}
                        </ColorButton>
                    </div>
                </div>
            </div>
            <div className="fixed w-screen h-screen top-0 left-0 z-10 bg-black/10" />
        </Form>
    )
}